<template>
  <div class="card-reader-box" v-if="getSocketConnected">
    <div class="card-reader-box-inner" v-if="getIsDeviceActivated">
      <v-icon color="success">mdi-check-circle</v-icon>
      <div>{{ $t('project.card_reader_found') }}</div>
    </div>
    <div class="card-reader-box-inner" v-else>
      <v-icon color="error">mdi-close-circle</v-icon>
      <div>{{ $t('project.card_reader_not_found') }}</div>
    </div>
    <div class="card-reader-box-inner">
      <template v-if="getIsCardInserted">
        <v-icon color="blue">mdi-card-account-details</v-icon>
        <div>{{ $t('project.found_card') }}</div>
      </template>
      <template v-else>
        <v-icon color="blue">mdi-card-account-details-outline</v-icon>
        <div>{{ $t('validate.please_insert_card') }}</div>
      </template>
      <template v-if="getReadData && getReadData.success">
        <div class="ml-2">{{ $t('project.card_read_success') }}</div>
        <v-icon color="success">mdi-check-bold</v-icon>
      </template>
      <template v-else-if="getReadData && !getReadData.success">
        <div class="text-red-400 ml-2">{{ $t('validate.error_read_card_check_card_again') }}</div>
        <v-icon color="error">mdi-check-circle</v-icon>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CardReaderBox",
  computed: {
    ...mapGetters({
      getSocketConnected: "socket/getSocketConnected",
      getIsCardInserted: "socket/getIsCardInserted",
      getIsDeviceActivated: "socket/getIsDeviceActivated",
      getReadData: "socket/getReadData"
    })
  },
  data() {
    return {};
  },
  props: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.card-reader-box {
  // position: sticky;
  // top: 0px;
  // z-index: 1;
  background: rgb(250, 250, 250);
  border: 1px solid rgba(202, 202, 202, 0.473);
  border-radius: 7px;
  min-height: 50px;
  margin-top: 15px;
  padding: 10px;
  .card-reader-box-inner {
    display: flex;
    align-items: center;
    i {
      font-size: 15px;
      margin: 0 5px;
    }
  }
}
</style>
